import React from 'react';
import Box from "../Box/Box";
import Button from "react-bootstrap/es/Button";
import PropTypes from 'prop-types';
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import FormGroup from "react-bootstrap/es/FormGroup";
import ControlLabel from "react-bootstrap/es/ControlLabel";
import CompanyService from "../../services/CompanyService";
import Table from "../Table/Table";

class CompanyParameterForm extends React.Component {

  companyService = new CompanyService();

  constructor(props) {
    super(props);
    this.state = {parameters: []};
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.companyService.findById(id).then(
          data => this.setState({loading: false, entity: data, parameters: data.parameters}),
          error => {
            this.setState({loading: false, message: 'Empresa não encontrada'});
            Notify.error('Falha ao buscar entidade: ', error);
          }
      )
    }
  }

  submitForm() {

    const entity = {
      name: this.name.value.trim(),
      value: this.value.value
    };

    this.state.parameters.push(entity);
    this.name.value = '';
    this.value.value = '';
    this.name.focus();
    this.setState(this.state);
    Notify.success('Item adicionado!');

  }

  render() {
    const {message, loading, parameters} = this.state;

    if (loading) {
      return <Loading/>
    }

    if (message) {
      return <h2>{message}</h2>;
    }

    const rowItem = ({name, value}, index) => (
        <tr key={index}>
          <td>{name}</td>
          <td>{value}</td>
          <td>
            <a href="" onClick={(e) => e.preventDefault() || this.removeByName(name)}>
              <i className="fa fa-trash" aria-hidden="true"></i>
            </a>
          </td>
        </tr>);

    return (
        <Box info>

          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome" required
                     name="name" ref={name => (this.name = name)}
              />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Valor</ControlLabel>
              <input type="text" className="form-control" placeholder="Valor" required
                     name="name" ref={value => (this.value = value)}
              />
            </FormGroup>


            <div className="row" style={{marginRight: 0}}>
              <div className="pull-right">
                <Button type="submit" bsStyle="success">Adicionar</Button>
              </div>
            </div>

          </form>

          <div className="table-responsive no-padding">
            <Table>
              <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
              </tr>
              </thead>
              <tbody>
              {parameters.map((item, index) => rowItem(item, index))}
              </tbody>
            </Table>
          </div>

          <div className="row" style={{marginRight: 0}}>
            <div className="pull-right">
              <Button className="btn btn-default" onClick={() => this.props.history.goBack()}>Cancelar</Button>
              <Button bsStyle="success" onClick={() => this.onSave()}>Salvar</Button>
            </div>
          </div>

        </Box>
    );
  }

  removeByName(nameToRemove) {
    const {parameters} = this.state;
    const newParamrs = parameters.filter(({name}) => name !== nameToRemove);
    this.setState({...this.state, parameters: newParamrs});
  }

  onSave() {
    const {entity, parameters} = this.state;
    entity.parameters = parameters;
    this.companyService.save(entity).then(
        () => Notify.success('Paramtros salvos!') || this.props.history.goBack(),
        (error) => Notify.error('Falha ao salvar parametros!', error)
    )
  }
}

CompanyParameterForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default CompanyParameterForm;


// WEBPACK FOOTER //
// ./src/component/Company/CompanyParameterForm.js